import React, { useEffect } from 'react';
import { Spinner, Input, Label, Col, Container, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import axios from 'axios';

import { useMutation, useQuery } from 'react-query';
import { useFormik } from 'formik';
import { guestSchema } from '../../validations/validation-schemas';

import useAxios from '../../sections/useAxios';


const GuestsCreation = () => {
  document.title = 'Guests Creation | SNB Offsite';

  const onSubmit = (values) => {

    const arrivalTime = new Date(`2000-01-01T${values.arrivalTime}`);
    const arrivalBoardingTime = new Date(`2000-01-01T${values.arrivalBoardingTime}`);
    
    const departureTime = new Date(`2000-01-01T${values.departureTime}`);
    const departureBoardingTime = new Date(`2000-01-01T${values.departureBoardingTime}`);

    let hasError = false; // Flag to track if any error occurred

    /* Flight checks disabled while flight fields are hidden
    if (new Date(values.arrivalDate) > new Date(values.departureDate)) {
      toast.error('Departure Date must be after Arrival Date');
      hasError = true;
    }
    
    if (arrivalTime < arrivalBoardingTime){
      toast.error('Arrival time must be after boarding time')
      hasError = true;
    }

    if (departureTime < departureBoardingTime){
      toast.error('Departure time must be after boarding time')
      hasError = true;
    }

    if ( !!values.arrivalFrom && !!values.arrivalTo && (values.arrivalFrom == values.arrivalTo)){
      toast.error('Arrival Flight cannot have same departure and arrival destination')
      hasError = true;
    }

    if (values.departureFrom == values.departureTo){
      toast.error('Departure Flight cannot have same departure and arrival destination')
      hasError = true;
    }
    */

    if (!hasError) {
      createGuestMutation.mutate(values);
    }
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit, resetForm, setFieldValue } = useFormik({
    initialValues: {
      title: '',
      firstName: '',
      lastName: '',
      phone: '',
      room_number: '',
      passport: '',
      authority: '',
      arrivalFrom: '',
      arrivalTo: '',
      arrivalFlightNumber: '',
      arrivalDate: '',
      arrivalTime: '',
      arrivalCarrier: '',
      arrivalBoardingTime: '',
      arrivalGate: '',
      arrivalAirportLocation: '',
      arrivalSeat: '',
      departureFrom: '',
      departureTo: '',
      departureFlightNumber: '',
      departureDate: '',
      departureTime: '',
      departureCarrier: '',
      departureBoardingTime: '',
      departureGate: '',
      departureAirportLocation: '',
      departureSeat: '',
    },
    validationSchema: guestSchema,
    onSubmit,
    enableReinitialize: true,
  })

  let api = useAxios();

  const createGuest = (payload) => {
    
    return api.post('/guests/create', payload);
  };

  console.log(errors)

  const navigate = useNavigate()

  const createGuestMutation = useMutation(createGuest, {
    onSuccess: (res) => {
      toast.success('Guest created')
      setTimeout(() => {
        navigate('/admin/guests-listing ')
      }, 1500);
    },
    onError: (res) => {      
      if (res?.response?.status === 400){
        if (res?.response?.data){
          toast.error(res?.response?.data)
        }
        else{
          toast.error('Something went wrong')
        }
      }
      else{
        toast.error('Something went wrong')  
      }
        
    }
  })



  return (
    <>
      <div className="container-fluid d-flex align-items-center mb-3" id="breadCrumbStyling">
        <nav aria-label="breadcrumb" className="d-flex align-items-center">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item text-white text-center active fs-4 pt-3 ps-2"
              aria-current="page"
              id="breadCrumbTitleStyling">
              New Guest Registration
            </li>
          </ol>
        </nav>
      </div>

      <div className='container-fluid bg-white px-md-5 px-3 py-md-5 py-3 mb-5' id='formStyling'>
        <form onSubmit={handleSubmit}>
          <h4 className='text-primary'>Guest Information</h4>
          <div className='row'>
        
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Title*</Label>
              <Input
                value={values.title}
                onChange={handleChange}
                onBlur={handleBlur}
                type="select"
                className={errors.title && touched.title ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="titleInput"
                name="title"
              >
                <option value="">Choose </option>
                <option value="Mr.">Mr. </option>
                <option value="Mrs.">Mrs. </option>
                <option value="Ms.">Ms. </option>
                <option value="Dr.">Dr. </option>
              </Input>
              {
                errors.title && touched.title && <div className="invalid-feedback">{errors.title}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">First Name*</Label>
              <Input
                value={values.firstName}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.firstName && touched.firstName ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="firstNameInput"
                placeholder="Enter First Name"
                name="firstName"
              />
              {
                errors.firstName && touched.firstName && <div className="invalid-feedback">{errors.firstName}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Last Name*</Label>
              <Input
                value={values.lastName}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.lastName && touched.lastName ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="lastNameInput"
                placeholder="Enter Last Name"
                name="lastName"
              />
              {
                errors.lastName && touched.lastName && <div className="invalid-feedback">{errors.lastName}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Phone No.*</Label>
              <Input
                value={values.phone}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.phone && touched.phone ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="phoneInput"
                placeholder="Enter Phone No."
                name="phone"
              />
              {
                errors.phone && touched.phone && <div className="invalid-feedback">{errors.phone}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Room No.</Label>
              <Input
                value={values.room_number}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className="form-control form-control-icon green-border col-6"
                id="room_numberInput"
                placeholder="Enter Room No."
                name="room_number"
              />
            </div>
          </div>


          {/* Flight details hidden for now
          <h4 className='mt-5 mb-1 text-primary'>Departure Flight</h4>
          <div className='row'>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">From*</Label>
              <Input
                value={values.departureFrom}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.departureFrom && touched.departureFrom ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="fromInput"
                placeholder="Where is the flight going from?"
                name="departureFrom"
              />
              {
                errors.departureFrom && touched.departureFrom && <div className="invalid-feedback">{errors.departureFrom}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">To*</Label>
              <Input
                value={values.departureTo}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.departureTo && touched.departureTo ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureToInput"
                placeholder="Where is the flight going to?"
                name="departureTo"
              />
              {
                errors.departureTo && touched.departureTo && <div className="invalid-feedback">{errors.departureTo}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Carrier*</Label>
              <Input
                value={values.departureCarrier}
                onChange={handleChange}
                onBlur={handleBlur}
                type="select"
                className={errors.departureCarrier && touched.departureCarrier ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureCarrierInput"
                name="departureCarrier"
              >
                <option value="">Choose</option>
                <option value="Saudia">Saudia</option>
                <option value="Emirates">Emirates</option>
                <option value="British Airways">British Airways</option>
                <option value="Qatar Airways">Qatar Airways</option>
                <option value="Etihad Airways">Etihad Airways</option>
              </Input>
              {
                errors.departureCarrier && touched.departureCarrier && <div className="invalid-feedback">{errors.departureCarrier}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Flight No.*</Label>
              <Input
                value={values.departureFlightNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.departureFlightNumber && touched.departureFlightNumber ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureFlightNumberInput"
                placeholder="Enter flight no."
                name="departureFlightNumber"
              />
              {
                errors.departureFlightNumber && touched.departureFlightNumber && <div className="invalid-feedback">{errors.departureFlightNumber}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Seat No.</Label>
              <Input
                value={values.departureSeat}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.departureSeat && touched.departureSeat ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalSeatInput"
                placeholder="Enter Airport Location"
                name="departureSeat"
              />
              {
                errors.departureSeat && touched.departureSeat && <div className="invalid-feedback">{errors.departureSeat}</div>
              }
            </div>
            
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Date*</Label>
              <Input
                value={values.departureDate}
                onChange={handleChange}
                onBlur={handleBlur}
                type="date"
                className={errors.departureDate && touched.departureDate ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureDateInput"
                name="departureDate"
              />
              {
                errors.departureDate && touched.departureDate && <div className="invalid-feedback">{errors.departureDate}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Departure Time*</Label>
              <Input
                value={values.departureTime}
                onChange={handleChange}
                onBlur={handleBlur}
                type="time"
                className={errors.departureTime && touched.departureTime ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureTimeInput"

                name="departureTime"
              />
              {
                errors.departureTime && touched.departureTime && <div className="invalid-feedback">{errors.departureTime}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Boarding Time</Label>
              <Input
                value={values.departureBoardingTime}
                onChange={handleChange}
                onBlur={handleBlur}
                type="time"
                className={errors.departureBoardingTime && touched.departureBoardingTime ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureBoardingTimeInput"
                placeholder="Enter departureBoardingTime"
                name="departureBoardingTime"
              />
              {
                errors.departureBoardingTime && touched.departureBoardingTime && <div className="invalid-feedback">{errors.departureBoardingTime}</div>
              }
            </div>


            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Gate</Label>
              <Input
                value={values.departureGate}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.departureGate && touched.departureGate ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureGateInput"
                placeholder="Enter departureGate"
                name="departureGate"
              />
              {
                errors.departureGate && touched.departureGate && <div className="invalid-feedback">{errors.departureGate}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Airport Location</Label>
              <Input
                value={values.departureAirportLocation}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.departureAirportLocation && touched.departureAirportLocation ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureAirportLocationInput"
                placeholder="Enter Airport Location"
                name="departureAirportLocation"
              />
              {
                errors.departureAirportLocation && touched.departureAirportLocation && <div className="invalid-feedback">{errors.departureAirportLocation}</div>
              }
            </div>
          </div>



          <h4 className='mt-5 mb-1 text-primary'>Stop (Only add if there is a stop in guest's flight)</h4>
          <div className='row'>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">From</Label>
              <Input
                value={values.arrivalFrom}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.arrivalFrom && touched.arrivalFrom ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="fromInput"
                placeholder="Where is the flight coming from?"
                name="arrivalFrom"
              />
              {
                errors.arrivalFrom && touched.arrivalFrom && <div className="invalid-feedback">{errors.arrivalFrom}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">To</Label>
              <Input
                value={values.arrivalTo}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.arrivalTo && touched.arrivalTo ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalToInput"
                placeholder="Where is the flight going to?"
                name="arrivalTo"
              />
              {
                errors.arrivalTo && touched.arrivalTo && <div className="invalid-feedback">{errors.arrivalTo}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Carrier</Label>
              <Input
                value={values.arrivalCarrier}
                onChange={handleChange}
                onBlur={handleBlur}
                type="select"
                className={errors.arrivalCarrier && touched.arrivalCarrier ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalCarrierInput"
                name="arrivalCarrier"
              >
                <option value="">Choose</option>
                <option value="Saudia">Saudia</option>
                <option value="Emirates">Emirates</option>
                <option value="British Airways">British Airways</option>
                <option value="Qatar Airways">Qatar Airways</option>
                <option value="Etihad Airways">Etihad Airways</option>
              </Input>
              {
                errors.arrivalCarrier && touched.arrivalCarrier && <div className="invalid-feedback">{errors.arrivalCarrier}</div>
              }
            </div>
            
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Flight No.</Label>
              <Input
                value={values.arrivalFlightNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.arrivalFlightNumber && touched.arrivalFlightNumber ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalFlightNumberInput"
                placeholder="Enter flight number"
                name="arrivalFlightNumber"
              />
              {
                errors.arrivalFlightNumber && touched.arrivalFlightNumber && <div className="invalid-feedback">{errors.arrivalFlightNumber}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Seat No.</Label>
              <Input
                value={values.arrivalSeat}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.arrivalSeat && touched.arrivalSeat ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalSeatInput"
                placeholder="Enter Airport Location"
                name="arrivalSeat"
              />
              {
                errors.arrivalSeat && touched.arrivalSeat && <div className="invalid-feedback">{errors.arrivalSeat}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Date</Label>
              <Input
                value={values.arrivalDate}
                onChange={handleChange}
                onBlur={handleBlur}
                type="date"
                className={errors.arrivalDate && touched.arrivalDate ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalDateInput"
                name="arrivalDate"
              />
              {
                errors.arrivalDate && touched.arrivalDate && <div className="invalid-feedback">{errors.arrivalDate}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Arrival Time</Label>
              <Input
                value={values.arrivalTime}
                onChange={handleChange}
                onBlur={handleBlur}
                type="time"
                className={errors.arrivalTime && touched.arrivalTime ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalTimeInput"
                name="arrivalTime"
              />
              {
                errors.arrivalTime && touched.arrivalTime && <div className="invalid-feedback">{errors.arrivalTime}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Boarding Time</Label>
              <Input
                value={values.arrivalBoardingTime}
                onChange={handleChange}
                onBlur={handleBlur}
                type="time"
                className={errors.arrivalBoardingTime && touched.arrivalBoardingTime ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalBoardingTimeInput"
                name="arrivalBoardingTime"
              />
              {
                errors.arrivalBoardingTime && touched.arrivalBoardingTime && <div className="invalid-feedback">{errors.arrivalBoardingTime}</div>
              }
            </div>


            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Gate</Label>
              <Input
                value={values.arrivalGate}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.arrivalGate && touched.arrivalGate ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalGateInput"
                placeholder="Enter Gate"
                name="arrivalGate"
              />
              {
                errors.arrivalGate && touched.arrivalGate && <div className="invalid-feedback">{errors.arrivalGate}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Airport Location</Label>
              <Input
                value={values.arrivalAirportLocation}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.arrivalAirportLocation && touched.arrivalAirportLocation ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalAirportLocationInput"
                placeholder="Enter Airport Location"
                name="arrivalAirportLocation"
              />
              {
                errors.arrivalAirportLocation && touched.arrivalAirportLocation && <div className="invalid-feedback">{errors.arrivalAirportLocation}</div>
              }
            </div>

          </div>
          */}

              <div className='text-end'>
                <button type='submit' className='btn admin-green-btn mt-4'
                  disabled={createGuestMutation.isLoading}>
                  {createGuestMutation.isLoading ? "Registering" : 'Register'}
                  {createGuestMutation.isLoading &&  <Spinner size="sm" className="flex-shrink-0 ms-2"/>}
                </button>
              </div>

        </form>
      </div>
    </>
  );
};

export default GuestsCreation;
